import { useAuthContext } from '@providers/AuthProvider';
import { Restricted } from '@providers/PermissionProvider/Restricted';
import { routes } from '@routes';
import { EPermission } from 'app/types/enums/EPermission';
import { useNavigate } from 'react-router';
import { TProps } from './types/TProps';

export const SelectedWorkspaceName = ({ isOpen, setWorkspaceListOpen, multipleWorkspacesInOrg }: TProps) => {
  const { workspace, organization } = useAuthContext();
  const navigate = useNavigate();

  const closeWorkspaceList = () => multipleWorkspacesInOrg && setWorkspaceListOpen(!isOpen);

  return (
    <>
      {isOpen ? (
        <span
          onClick={closeWorkspaceList}
          className="leading-[30px] w-full whitespace-nowrap overflow-hidden text-ellipsis pl-2 pr-5 m-0"
        >
          {workspace?.name ?? 'Workspaces'}
        </span>
      ) : (
        <div className="ml-2">
          <Restricted
            to={EPermission.manageWorkspaces}
            fallback={
              <span
                onClick={closeWorkspaceList}
                className="block font-semibold text-xs leading-[130%] -mt-0.5 max-w-[140px] overflow-hidden text-ellipsis whitespace-nowrap"
                style={{ lineHeight: '250%' }}
              >
                {workspace?.name}
              </span>
            }
          >
            <span
              onClick={closeWorkspaceList}
              className="block font-semibold text-xs leading-[130%] -mt-0.5 max-w-[140px] overflow-hidden text-ellipsis whitespace-nowrap"
            >
              {workspace?.name}
            </span>
            <span
              onClick={() => navigate(routes.workspaceDetails.make(organization?.slug, workspace?.slug))}
              className="flex flex-none relative -mt-0.5 hover:text-[var(--color-title)]"
            >
              <span className="inline-block h-4 leading-5 mr-1 text-xs">Details</span>
              {/* <GearSvg style={{ width: '12px' }} />*/}
            </span>
          </Restricted>
        </div>
      )}
    </>
  );
};
